






















import { Component, Vue, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { isArray } from 'util';

@Component({
  components: {
  },
})
export default class LaneSelect extends Vue {
  @Prop({ required: false, default: false })
  public adminVersion = false;

  @Prop({ type: String, required: true })
  public centerName!: string;

  @Prop({ type: Number, required: true })
  public numLanes!: number;

  @Prop({ type: Array, required: true })
  public activeLanes!: number[];

  @Prop({
    type: Array,
    required: true,
    validator: (v: any) => isArray(v) && v.every((n) => isArray(n.activeLanes) && n.id && n.laneConfig),
  })
  public activeSessions!: Array<{ activeLanes: number[], id: string, laneConfig: string }>;

  public onLaneClick(lane: number) {
    this.$emit('onLaneSelected', lane);
  }

  public isLaneActive(lane: number) {
    return this.activeLanes.indexOf(lane) > -1;
  }

  public getGameString(lane1: number, lane2: number) {
    const sessions = this.activeSessions
      .filter((s) => s.activeLanes.indexOf(lane1) > -1 || s.activeLanes.indexOf(lane2) > -1);

    if (sessions.some((s) => s.laneConfig === 'CROSS_LANE')) {
      return `game on lanes ${lane1} and ${lane2}`;
    } else if (sessions.length > 0) {
      return [lane1, lane2]
        .map((l) => sessions.some((s) => s.activeLanes.indexOf(l) > -1) ? `game on lane ${l}` : null)
        .filter((s) => !!s)
        .join('<br>');
    }

    return 'no game in play';
  }
}
